import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _IconMoreVert;
var _excluded = ["sx"];
import * as React from 'react';
import _ from 'lodash';
import { useIntl } from '@lumahealthhq/ui-components';
import { Box, IconButton, IconMoreVert, Skeleton, extendSX } from '@lumahealthhq/ui-core';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function FallbackContainerPatientInfo(_ref) {
  var sx = _ref.sx,
    props = _objectWithoutProperties(_ref, _excluded);
  var intl = useIntl();
  return /*#__PURE__*/_jsxs(Box, _extends({
    sx: extendSX(sx, {
      width: '100%',
      display: 'flex',
      height: '60px',
      alignItems: 'flex-end',
      px: 3
    })
  }, props, {
    children: [/*#__PURE__*/_jsx(Skeleton, {
      sx: {
        height: '56px',
        width: '56px',
        transform: 'none',
        borderRadius: '50%'
      }
    }), /*#__PURE__*/_jsx(Box, {
      sx: {
        px: 3
      },
      children: _.times(2, function (key) {
        return /*#__PURE__*/_jsx(Skeleton, {
          sx: {
            height: '28px',
            width: key === 0 ? '220px' : '180px'
          }
        }, key);
      })
    }), /*#__PURE__*/_jsx(Skeleton, {
      sx: {
        height: '28px',
        width: '360px'
      }
    }), /*#__PURE__*/_jsx(Box, {
      sx: {
        p: 1,
        bgcolor: 'white',
        borderRadius: 56,
        marginLeft: 'auto',
        alignSelf: 'center'
      },
      children: /*#__PURE__*/_jsx(IconButton, {
        "aria-label": intl.formatMessage({
          id: "gk3x/E",
          defaultMessage: [{
            "type": 0,
            "value": "more"
          }]
        }),
        size: "large",
        disabled: true,
        children: _IconMoreVert || (_IconMoreVert = /*#__PURE__*/_jsx(IconMoreVert, {
          fontSize: "small"
        }))
      })
    })]
  }));
}